export default function getColorClassByDistance(distance: number) {
  if (distance < 6) {
    return "text-[#ededed]";
  }
  if (distance < 20) {
    return "text-[#adadad]";
  }
  if (distance < 34) {
    return "text-[#666666]";
  }

  return "text-[#333333]";
}
